import { defineStore } from 'pinia'
import { shallowRef } from 'vue'
import { v4 as uuid4 } from 'uuid'

export const useModalStack = defineStore('modalstack', () => {
  const stack = shallowRef([])

  async function push({ component, onClose, props, events, componentRef }) {
    const stk = [...stack.value]
    let cmp = component

    if (cmp instanceof Function) {
      const res = await cmp()
      cmp = res.default
    }

    stk.push({
      component: cmp,
      props: { ...(props || {}), modalstack: true },
      events: { ...(events || {}), ['modalstack:close']: pop },
      id: uuid4(), // using this as key in v-for loop, should be unique
      onClose,
      componentRef,
    })
    stack.value = stk
  }

  function pop(data = null) {
    const stk = [...stack.value]
    const stki = stk.pop()

    if (data !== null && stki.onClose instanceof Function) {
      stki.onClose(data)
    }
    stack.value = stk
  }

  return {
    push,
    pop,
    stack,
  }
})
